import { render, staticRenderFns } from "./InfoMap.vue?vue&type=template&id=b84ff3b6&scoped=true&"
import script from "./InfoMap.vue?vue&type=script&lang=js&"
export * from "./InfoMap.vue?vue&type=script&lang=js&"
import style0 from "./InfoMap.vue?vue&type=style&index=0&id=b84ff3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ff3b6",
  null
  
)

export default component.exports